<div id="{{Id}}-Selected" 
  [ngClass]="columnInfoDto.IsReadOnly || dataItem.IsDelete? 'not-allowed can-be-selected' : 'can-be-selected'">
    <span [ngClass]="columnInfoDto.InFND? 'splitscreen-fnd' : 'splitscreen'" class="mat-form-field-outline-thick">
      <div class="pd-inline-block">
        <input type="text"
          #autoInput="matAutocompleteTrigger"
          matInput
          id="{{Id}}-Input"
          name="{{ baseId }}-input"
          class="emds-find-control-text-input"
          [readonly]="dataItem.IsDelete"
          placeholder="{{name}}"
          aria-label="Number"
          [matAutocomplete]="auto"
          spellcheck="false"
          (focus)="inputFocused()"
          (blur)="inputBlurred()"
          (click)="inputFocused()"
          [ngClass]="dataItem.IsDelete? 'pd-input not-allowed pd-disabled left' : 'pd-input left'"
          >
      </div>
      <span id="{{Id}}-Icon" class="right mat-icon">
        <div class="pd-inline-block">
        <mat-icon #myIcon [ngClass]="columnInfoDto.IsReadOnly || dataItem.IsDelete? 'not-allowed right' : 'right'" 
          class="pd-float-right mat-icon emds-find-control-icon clickable material-icons mat-ligature-font mat-icon-no-color" 
          (click)="clickIcon()">search
        </mat-icon>
        </div>
      </span>
    </span>

  <mat-autocomplete panelWidth="240px"
    class="emds"
    autoActiveFirstOption
    #auto="matAutocomplete"
    (opened)="onAutoCompleteOpen()"
    (closed)="onAutoCompleteClose()"
    >
    <div role="listbox" 
    class="mat-autocomplete-panel emds mat-primary mat-autocomplete-visible" 
    id="{{Id}}">
    <mat-optgroup
      class="find-control-dropdown-group"
      *ngFor="let group of autocompleteGroups"
      [label]="group.Name"
      [hidden]="!group.Name"
      id="{{Id}}-dropdown"
    >
      <span *ngIf="group.isCollapsable" class="center-icon pull-right" id="{{ baseId }}-toggle-collapse" (click)="toggleCollapsed($event, group)">
        <div class="ap-down-chevron" *ngIf="group.isCollapsed" #matOptgroupLabel></div>
        <div class="ap-up-chevron" *ngIf="!group.isCollapsed" #matOptgroupLabel></div>
      </span>
      <mat-option *ngFor="let option of group.ItemList" (click)="changeDropdown($event)"
        id="{{Id}}-Select"
        [hidden]="group.isCollapsed" 
        [disabled]="group.GroupDisabled">
        {{getFormattedName(option)}}
      </mat-option>
      <mat-option *ngIf="!group.ItemList.length && !group.isCollapsed" [disabled]="true" translate> No items available </mat-option>
    </mat-optgroup>
    </div>
  </mat-autocomplete>
</div>
